import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import { SITE, SOCIALS } from "@/lib/site";
import { Container, Wordmark } from "@/components/common/ui";
import { SoundToggle } from "@/components/common/SoundToggle";

const ICONS = { facebook: Facebook, instagram: Instagram, linkedin: Linkedin, youtube: Youtube, twitter: Twitter };

const COLS = [
  { title: "Search", links: [["/search", "All homes"], ["/bases", "Homes by base"], ["/search?region=Hampton+Roads", "Hampton Roads"], ["/search?region=Greater+Richmond", "Greater Richmond"]] },
  { title: "Military", links: [["/military", "PCS relocation"], ["/bases", "Bases & shipyards in 3D"], ["/military#va-loans", "VA loan basics"], ["/military#pcs-checklist", "PCS checklist"]] },
  { title: "Buy & Sell", links: [["/buyers", "Buyers guide"], ["/buyers#calculator", "Mortgage calculator"], ["/sellers", "Sellers guide"], ["/sellers#market-analysis", "Free market analysis"]] },
  { title: "Company", links: [["/about", "About the team"], ["/about#testimonials", "Testimonials"], ["/contact", "Contact"], ["/contact?kind=career", "Careers"]] },
];

export const SiteFooter = () => (
  <footer className="border-t border-neutral-200 bg-white pb-28 pt-16 lg:pb-12" data-testid="site-footer">
    <Container>
      <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]">
        <div>
          <Wordmark />
          <p className="mt-5 max-w-sm text-[15px] text-neutral-600">
            {SITE.companies.join(" · ")}. {SITE.serviceArea} real estate, with a 30-year retired Navy Senior Chief as our Broker in charge.
          </p>
          <div className="mt-6 space-y-1 text-[15px] text-ink">
            <a href={SITE.phoneMainHref} className="block hover:underline" data-testid="footer-phone-main">{SITE.phoneMain}</a>
            <a href={SITE.phoneOfficeHref} className="block hover:underline" data-testid="footer-phone-office">Office {SITE.phoneOffice}</a>
            <a href={`mailto:${SITE.email}`} className="block hover:underline" data-testid="footer-email">{SITE.email}</a>
            <a href={SITE.directionsUrl} target="_blank" rel="noreferrer" className="block text-neutral-600 hover:underline" data-testid="footer-address">
              {SITE.officeName}, {SITE.street}, {SITE.cityLine}
            </a>
          </div>
          <div className="mt-6 flex gap-2">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.id];
              return (
                <a key={s.id} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label} data-testid={`footer-social-${s.id}`}
                  className="grid h-9 w-9 place-items-center rounded-full border border-neutral-300 text-ink transition-colors hover:bg-ink hover:text-white">
                  <Icon className="h-4 w-4" />
                </a>
              );
            })}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          {COLS.map((c) => (
            <div key={c.title}>
              <p className="mb-4 text-[13px] font-medium uppercase tracking-[0.16em] text-neutral-500">{c.title}</p>
              <ul className="space-y-2.5">
                {c.links.map(([to, label]) => (
                  <li key={to}>
                    <Link to={to} className="text-[15px] text-ink hover:underline" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-14 space-y-3 border-t border-neutral-200 pt-6 text-xs leading-relaxed text-neutral-500">
        <p>
          Home listings on this site are currently SAMPLE listings for demonstration only and are not properties for sale.
          Live listings will be provided by REIN, Inc. (Real Estate Information Network) once the IDX data feed is approved;
          information deemed reliable but not guaranteed. Distances to installations are straight-line estimates.
        </p>
        <p className="flex flex-wrap items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} 757 Realty · 804 Homes · Atlantic Coast Realty. Equal Housing Opportunity.</span>
          <span className="flex items-center gap-4">
            <SoundToggle />
            <Link to="/admin" className="hover:underline" data-testid="footer-admin-link">Team login</Link>
          </span>
        </p>
      </div>
    </Container>
  </footer>
);
